/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from "react";
import IconTextRow from "./IconTextRow";
import DateTimeSection from "./DateTimeSection";
import LabeledTextSection from "./LabeledTextSection";
import EvidenceSection from "./EvidenceSection";
import {IconGuardTitle} from "../../../../../../../../components/buttons/IconButtons";
import {EMPTY_VALUES, sanitizeString} from "../../../../../../../../Apis/functions";

/**
 * Movement as the guard at the gate registered it: who attended it, when it
 * happened, the notes of the movement and its evidence.
 *
 * The title is received because the same record describes the arrival of the
 * vehicle or the exit of the trip, depending on the moment of the folio.
 *
 * Every value of the record is written at the gate, so the one the guard left
 * blank is read with the text the detail declares for it and is never completed
 * with what the folio was requested with: the record says what the gate wrote
 * and nothing else.
 */
const MovementRecordSection = ({
                                   t,
                                   title,
                                   item,
                                   evidence,
                                   registeredBy,
                                   date,
                                   notes,
                                   fillHeight,
                                   evidenceTrans,
                                   emptyText = EMPTY_VALUES.DEFAULT
                               }) => {
    return (
        <>
            <p className='font-color-general-950 fs-14px ibl-font-w-600'>
                {t(title)}
            </p>

            <IconTextRow Icon={IconGuardTitle} text={sanitizeString(registeredBy) || emptyText}/>

            <div className={'border-bottom-shades-300 my-3'}/>

            <DateTimeSection t={t} date={date} emptyText={emptyText}/>

            <div className={'border-bottom-shades-300 my-3'}/>

            <LabeledTextSection
                t={t}
                title={'notes'}
                value={sanitizeString(notes)}
                emptyText={emptyText}
            />

            <div className={'border-bottom-shades-300 mt-3'}/>

            <EvidenceSection
                t={t}
                item={item}
                evidence={evidence}
                fillHeight={fillHeight}
                {...(evidenceTrans ? {title: evidenceTrans} : {})}
            />
        </>
    );
};

export default MovementRecordSection;
